<h2 mat-dialog-title>Result Processing</h2>
<mat-dialog-content class="mat-typography">
  <div class="partion_container">

    <div class="parti_cl parti_par">
      <h3 class="text-center">Done</h3>

      <ul class="parti_ul">
        <li class="parti_li donel" *ngFor="let cl of done">
          <span class="parti_span">
            <div class="texter" *ngIf="!cl?.errorMsgProcess;else err;">
              {{cl.name}}
            </div>
            <ng-template #err>
              <div class="texter">
               Client:- <span>{{cl.name}}</span> <br />
              Message:-<span>{{cl?.errorMsgProcess}}</span>
              </div>
            </ng-template>

          </span>
        </li>

      </ul>
    </div>




    <div class="parti_selected parti_par">
      <h3 class="text-center">Failed</h3>
      <ul class="parti_ul">
        <li class="parti_li faill" *ngFor="let cl of declined">
          <span class="parti_span">
            <div class="texter failed_texter">
              Client:- <span>{{cl.name}}</span> <br />
              Reason:-<span>{{cl.errorMsgProcess}}</span>
</div>
          </span>
        </li>
      </ul>
    </div>

  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close cdkFocusInitial>Close</button>
</mat-dialog-actions>
